// src/collection/collection-context.ts
import { createContext } from "react";
var CollectionContext = createContext(
  void 0
);

export {
  CollectionContext
};
